import React from 'react'
import Configs from '@/configs'
import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import TermsConditionBanner from '@/components/banners/TermsConditionBanner'

function TermsAndConditions() {
  return (
    <>
      <Meta
        title={META_CONTENTS.terms.title}
        keywords={META_CONTENTS.terms.keywords}
        description={META_CONTENTS.terms.description}
      />

      <TermsConditionBanner />

      <section className='for-whom-section pt-16 pb-16'>
        <div className='container mx-auto'>
          <div className='row justify-center'>
            <div className='w-full'>
              <p className='mb-7'>
                Welcome to www.shipandstorage.com (the "Website"). Please read these Terms and Conditions carefully, as
                they constitute a written agreement between you and Ship And Storage (“SAS”, “we”, “our”, or “us”), and
                they affect your legal rights and obligations. By signing up and accessing the Website (other than to
                simply read these Terms), you agree and acknowledge to be bound by and comply with these Terms and any
                Additional Terms (defined below) then posted.
              </p>

              <h3 className='text-3xl sm-mx:text-xl font-bold text-secondary mb-3.5'>Acceptance of Terms</h3>
              <p className='mb-5'>
                Ship And Storage will review the terms every quarter and may post the revised terms on the website. You
                will not be notified of this action. You are responsible to check this Terms and Conditions page
                periodically for changes. IF YOU DO NOT AGREE TO THESE TERMS OF USE, PLEASE DO NOT USE THE SITE AND ITS
                SERVICES.
              </p>

              <p className='mb-5'>
                By submitting an order through the website, not only you agree to and acknowledge our Terms, but the
                carrier’s (refers to the third-party shipping company Ship And Storage uses to provide the shipping
                services) Terms and Conditions as well.
              </p>
              <p>
                FedEx:{' '}
                <a
                  href='https://www.fedex.com/en-us/terms-of-use.html'
                  target='_blank'
                  className='text-secondary underline break-words'
                >
                  Terms of Use
                </a>
              </p>

              <h3 className='text-3xl sm-mx:text-xl font-bold text-secondary mt-7 mb-3.5'>Use of the website</h3>
              <p className='mb-8'>As a condition of your use of the website, you warrant that:</p>
              <ul className='list-disc pl-5 mb-10'>
                <li className='pl-4'>You are at least 18 years of age.</li>
                <li className='pl-4'>
                  You will use your name as shown in your government ID when signing up with us and placing order.
                </li>
                <li className='pl-4'>You possess the legal authority to create a binding legal obligation.</li>
                <li className='pl-4'>You will use the website in accordance with the terms.</li>
                <li className='pl-4'>
                  You will only use the website to make legitimate reservations of services for you or the other person
                  you are on behalf of
                </li>
                <li className='pl-4'>
                  You will inform such other persons about the terms that apply to the services you have made on their
                  behalf, including all rules and restrictions applicable thereto.
                </li>
                <li className='pl-4'>
                  All information provided by you on website is true, accurate, current and complete.
                </li>
                <li className='pl-4'>
                  If you opened an account with Ship And Storage, you will safeguard your account information and will
                  supervise and be completely responsible for any use of your account by you and anyone other than you.
                </li>
                <li className='pl-4'>
                  You agree to comply with all applicable laws, statues, ordinances and regulations regarding use of
                  Ship And Storage services.
                </li>
              </ul>
              <p className='mb-4'>
                Ship And Storage retains the right, at our sole discretion, to deny or terminate your access to the
                website and services at any time and for any reason, including but not limited to violation of the
                terms.
              </p>

              <h3 className='text-3xl sm-mx:text-xl font-bold text-secondary mt-7 mb-3.5'>Description of services</h3>
              <p className='mb-5'>
                Ship And Storage provides a web platform to quote, arrange, and facilitate the shipment and storage of
                luggage, boxes, and sports equipment (the “Packages”). You select the carrier for your shipping order
                and acknowledge that Ship And Storage will use the carrier to transport your packages. You acknowledge
                that the other third parties (refer to person or organization) at the pickup or delivery address of your
                order are responsible for handing over or accepting your packages on behalf of you. Ship And Storage or
                the carrier reserves the right to refuse, cancel, return, or hold any shipment if the shipment does not
                comply with the terms, is undeliverable, may contain possible dangerous, illegal or prohibited items, or
                is not properly packed. You acknowledge that you ship your packages through the service at your own
                risk. If your packages are lost in transit on the way to us or to you, you can request Ship And Storage
                to submit a claim to the carrier.
              </p>
              <p className='mb-5'>
                Ship And Storage and/or the carrier may conduct a reasonable investigation into your claim, but in no
                event is Ship And Storage required or obligated to investigate any claims pertaining to lost, damaged or
                delayed shipment. You acknowledge and agree that your request for assistance from Ship And Storage,
                and/or any reasonable investigation into your claim, does not entitle you to compensation or damages
                from Ship And Storage, or any action or recourse by Ship And Storage, and that a commercially reasonable
                investigation is your sole and exclusive remedy. You acknowledge that the Services are also subject to
                any terms imposed by subcontractors of Ship And Storage and all carriers Ship And Storage uses.
              </p>

              <h3 className='text-3xl sm-mx:text-xl font-bold text-secondary mt-7 mb-3.5'>Storage Services</h3>
              <p className='mb-5'>
                Ship And Storage provides 6 months of free storage services for each package if you use our shipping
                services from your location to our warehouse, and from our warehouse back to you. After 6 months, the
                monthly storage fee for each package is $10 USD. This monthly fee will be charged automatically to your
                account. If we are unable to charge your account, get in contact with you, and the storage fee is due
                over 3 months, you agree that Ship And Storage has the right to destroy your package(s).
              </p>
              <p className='mb-5'>
                Ship And Storage is not responsible for any item damaged due to improper packaging. Ship And Storage’s
                liability coverage for the storage service is up to 250 USD each package. Ship And Storage has the right
                to refuse or return those packages that cannot be accepted or stored in our warehouse. You will be
                responsible for related return shipping and handling fee.
              </p>
              <p className='mb-5'>
                Ship And Storage cannot accept packages over 72 inches in length or 100 lbs. in weight. Ship And Storage
                is not able to provide storage service for those prohibited items described in this term.
              </p>

              <h3 className='text-3xl sm-mx:text-xl font-bold text-secondary mt-7 mb-3.5'>
                Rates and Rate Adjustments
              </h3>
              <p className='mb-4'>
                You understand all rates quoted on the website,{' '}
                <a href={Configs.appURL} className='text-secondary underline'>
                  {Configs.APP_NAME}
                </a>
                , or by a Ship And Storage representative, are in US dollars. By placing an order with Ship And Storage,
                you agree to pay for the order in US dollars.
              </p>

              <p className='mb-4'>
                Rates generated on the website,{' '}
                <a href={Configs.appURL} className='text-secondary underline'>
                  {Configs.APP_NAME}
                </a>
                , or by a Ship And Storage representative, are based on the information provided by you at the time of
                inquiry. Final rates will be based on the actual weight and dimension verified by the carrier, and
                actual services provided by the carrier and Ship And Storage.
              </p>

              <p className='mb-4'>
                Dimensions are measured from the widest point of each side of the package. If the actual weight or
                dimension of any shipped package exceeds the maximum allowed for the quoted item category, rates may
                adjust to reflect the billing weight. The billing weight is the greater one of the actual weight and
                dimensional weight of each package. The dimensional weight of an item can be calculated by multiplying
                length, width, and height, in inches, and dividing by 139 (L*W*H/139).
              </p>

              <p className='mb-4'>
                If additional service is provided to your shipment, included but not limited to address correction after
                pickup, package hold service, re-pick up service, remote area delivery, package re-route service,
                package return service, and so forth, related fees will be added to the final cost. You can find
                detailed surcharge information and prices via below carrier links:
              </p>

              <p>
                <a
                  href='https://www.fedex.com/en-us/shipping/current-rates/surcharges-and-fees.html#fedex-express-ground/'
                  target='_blank'
                  className='text-secondary underline break-words'
                >
                  Fedex surcharges
                </a>
              </p>
              <p className='mb-4'>
                <a
                  href='https://www.dhl-usa.com/en/express/shipping/shipping_advice/surcharges.html'
                  target='_blank'
                  className='text-secondary underline break-words'
                >
                  DHL surcharges
                </a>
              </p>
              <p className='mb-4'>
                If the final rates differ from quoted rates, you acknowledge and agree Ship And Storage to charge or
                refund the difference without notice. A final invoice with order breakdown will be provided to you upon
                request after the final charge or final refund is processed.
              </p>

              <h3 className='text-3xl sm-mx:text-xl font-bold text-secondary mt-7 mb-3.5'>
                Delivery Time and Shipment Delay
              </h3>
              <p className='mb-4'>
                The delivery time generated on the website{' '}
                <a href={Configs.appURL} className='text-secondary underline'>
                  {Configs.APP_NAME}
                </a>
                , or by a Ship And Storage representative, is based on the shipping date and services you selected. The
                actual delivery date will be based on the actual date the shipment is picked up by the carrier from the
                pickup address or the drop-off location.
              </p>
              <p className='mb-4'>
                The delivery time posted on the website is an estimated time and is not guaranteed. Many factors can
                delay the shipment, such as weather conditions, traffic, lockdowns, etc. You acknowledge that Ship And
                Storage will not be responsible for any direct or indirect losses, or personal or business losses,
                caused by the delayed shipment.
              </p>
              <p className='mb-4'>
                Ship And Storage will make every effort to communicate with the carrier and have them deliver the
                package on time. If the shipment was tendered to the carrier on schedule, while a delay of more than 6
                hours is caused by the carrier, Ship And Storage will adjust the cost to the next service that relates
                to the delayed time. This applies for below services (excluding delays caused by factors mentioned in
                the following paragraphs).
              </p>
              <ul className='list-disc pl-5 mb-10'>
                <li className='pl-4'>US Domestic Express 1-Day Service</li>
                <li className='pl-4'>US Domestic Priority 2-Day Service</li>
                <li className='pl-4'>US Domestic Standard 3-Day Standard Service</li>
              </ul>
              <p className='mb-4'>Ship And Storage is not responsible for any shipment delay due to:</p>
              <ul className='list-disc pl-5 mb-10'>
                <li className='pl-4'>failed or missed pickup caused by carrier or your party,</li>
                <li className='pl-4'>
                  dropping off the package(s) after the service cut-off time at the drop-off location,
                </li>
                <li className='pl-4'>on-hold shipment requested by you,</li>
                <li className='pl-4'>improperly packing or labeling of the package,</li>
                <li className='pl-4'>
                  wrong, inaccurate, or incomplete delivery address or receiver information provided by you,
                </li>
                <li className='pl-4'>
                  business closed or absence or refusal of a person to sign for the shipment at the delivery address,
                </li>
                <li className='pl-4'>delayed response or action taken to customs officers requirements</li>
                <li className='pl-4'>customs delay, customs or carrier inspection,</li>
                <li className='pl-4'>acts of God (e.g., earthquake, storm, flood, fog etc.),</li>
                <li className='pl-4'>acts of public authorities acting with actual or apparent authority of law</li>
                <li className='pl-4'>
                  strike, lock-out, stoppage or restraint of labor, the consequences of which we are unable to avoid by
                  the exercise of reasonable diligence,
                </li>
                <li className='pl-4'>any other uncontrollable delay reason listed on FedEx and DHL terms.</li>
              </ul>
              <p className='mb-4'>
                You acknowledge that there is no delivery time guaranteed for these services. Packages may be delivered
                before or after the estimated delivery date.
              </p>

              <h3 className='text-3xl sm-mx:text-xl font-bold text-secondary mt-7 mb-3.5'>Order modification</h3>
              <p className='mb-4'>
                You can modify your order online any time before the order is processed at no extra cost. You
                acknowledge and agree that Ship And Storage will process the modified order and charge you the updated
                order total applicable to the respective changes.
              </p>
              <p className='mb-4'>
                If the order is already processing, Ship And Storage will assist you to modify the order. An order
                modification fee, no more than 20USD, may apply. You acknowledge and agree that Ship And Storage will
                charge or refund the difference if the modification results in a price change.
              </p>
              <p className='mb-4'>
                Once the shipment is picked up by the carrier, the order cannot be modified anymore. If a modification
                must be made to guarantee the delivery, such as correcting the wrong delivery address, or requesting a
                shipment hold, Ship And Storage will put all efforts to communicate with the carrier, but the result is
                not guaranteed. Additional correction or processing fee will be charged by the carrier and applied to
                you.
              </p>

              <h3 className='text-3xl sm-mx:text-xl font-bold text-secondary mt-7 mb-3.5'>Cancellation Policy</h3>
              <p className='mb-4'>
                Ship And Storage understands that plans can change. We will process a full refund if you cancel your
                order within 24 hours after your order was submitted and no shipping labels were yet provided to you.
              </p>
              <p className='mb-4'>
                If you cancel your order after 24 hours from when your order was submitted, or the shipping labels have
                already been provided to you, there will be a 20USD cancellation fee charged to your account. The refund
                will be processed in 15 business days.
              </p>

              <h3 className='text-3xl sm-mx:text-xl font-bold text-secondary mt-7 mb-3.5'>
                Packing, Locking, and Labeling
              </h3>
              <p className='mb-4'>
                It is your responsibility to select a strong and sturdy luggage/case/box, to pack and protect your items
                properly. You acknowledge that Ship And Storage will not be responsible for any damaged or lost shipment
                due to improper packing.
              </p>
              <p className='mb-4'>
                You agree not to overpack and exceed the package maximum size and maximum weight of the order. You agree
                to pay for the weight and/or size difference and related surcharges if the package exceeds the size and
                weight limit of the item catalog when you placed the order.
              </p>
              <p className='mb-4'>
                It is your responsibility to lock all packages if shipping domestically within the US. Ship And Storage
                is not responsible for any lost content if the unlocked package is shipped domestically.
              </p>
              <p className='mb-4'>
                If you are shipping internationally after using our storage services, please do not lock your
                luggage/bag/case. It is your responsibility not to lock your packages for international shipment. You
                understand that customs or carrier may return the locked package if they are unable to open it for a
                regular customs screening. Ship And Storage is not responsible for any shipment loss or delay because of
                the locked package. We are unable to remove the locks for you.
              </p>
              <p className='mb-4'>
                It is your responsibility to follow the shipping instructions and correctly attach the shipping labels
                to the package. Ship And Storage is not responsible for any lost or delayed shipment due to improper
                labeling. It is your responsibility to send Ship And Storage a picture(s) of your labeled
                luggage/box/bag before you hand the luggage/box/bag to the carrier. You understand your lost or damage
                claim will not be accepted by the carrier if you do not send the picture before the shipment. Ship And
                Storage will not be responsible for any rejected claim because of lack of picture evidence.
              </p>
              <p className='mb-4'>
                The shipping label Ship And Storage created for your order can only be used for the respective
                package(s) you ordered, and the package(s) should be picked up or dropped off at the same location you
                requested in the order. Ship And Storage is not responsible for any delay, return, loss, damage,
                customs, or carrier shipment abandon if the label is used on more than one package, or package(s)
                shipped from different locations or at different times. Ship And Storage keeps the right to charge you
                all additional costs billed from the carrier.
              </p>

              <h3 className='text-3xl sm-mx:text-xl font-bold text-secondary mt-7 mb-3.5'>
                International Prohibited Items
              </h3>
              <p className='mb-4'>
                You agree and acknowledge that you will not send anything which may be construed as illegal in any way,
                such as stolen items; and that you will not pack or ship any prohibited items listed below:
              </p>
              <ul className='list-disc pl-5 mb-10'>
                <li className='pl-4'>Animals, animal products, and human remains;</li>
                <li className='pl-4'>Aerosols or any other pressurized containers;</li>
                <li className='pl-4'>Alcohol, or any goods containing alcohol, including perfumes;</li>
                <li className='pl-4'>Bullion, currency, or other forms of tradeable currency; credit cards;</li>
                <li className='pl-4'>Batteries, included with personal devices;</li>
                <li className='pl-4'>
                  Drugs, including all illegal narcotics, all drugs prohibited by any jurisdiction through which your
                  package will or may travel, as well as prescription drugs; medical samples.
                </li>
                <li className='pl-4'>
                  Firearms and firearm parts, ammunition, explosives, weapons (including imitations of same);
                </li>
                <li className='pl-4'>Flowers and plant products;</li>
                <li className='pl-4'>Perishable food articles and beverages;</li>
                <li className='pl-4'>
                  Hazardous/dangerous materials and goods, including, without limitation, hazardous or corrosive
                  materials, explosives, flammable or combustible materials, infectious substances, poisons, dry ice,
                  fireworks, or radioactive materials; and hazardous waste.
                </li>
                <li className='pl-4'>Pornography;</li>
                <li className='pl-4'>Tobacco;</li>
                <li className='pl-4'>
                  Valuables, high value or irreplaceable items including but not limited to antiques, paintings,
                  jewelry, precious stones;
                </li>
                <li className='pl-4'>Vape products</li>
                <li className='pl-4'>
                  Lottery tickets or gambling devices in violation of the laws of any jurisdiction through which your
                  package will or may travel;
                </li>
                <li className='pl-4'>
                  Other illegal or restricted goods defined by any shipping partner, or any local, state, federal,
                  international law and regulation. Check your destination country regulations, and Terms and Conditions
                  on the courier’s website.
                </li>
              </ul>

              <p className='mb-4'>
                Please know in advance if you will be shipping internationally after using our storage services. There
                might be additional prohibited items specified by the destination country. The carrier may, at its sole
                discretion, refuse to carry other items not listed here. It is your responsibility to check the local
                customs law and regulation before shipping.
              </p>
              <p className='mb-4'>
                You agree not to ship packages that are wet, leaking, or emitting an odor of any kind. Ship And Storage
                retains the right to update the prohibited item list any time to comply with related law or regulation.
                Ship And Storage and the carrier company reserve the right to open and inspect any item shipped by you.
              </p>

              <h3 className='text-3xl sm-mx:text-xl font-bold text-secondary mt-7 mb-3.5'>Storage Prohibited Items</h3>
              <p className='mb-4'>
                We do not have much restrictions on what you can store in our facility, except for any items that may be
                construed as illegal or hazardous/dangerous, such as:
              </p>
              <ul className='list-disc pl-5 mb-10'>
                <li className='pl-4'>
                  Firearms and firearm parts, ammunition, explosives, weapons (including imitations of same);
                </li>
                <li className='pl-4'>
                  Hazardous/dangerous materials and goods, including, without limitation, hazardous or corrosive
                  materials, explosives, flammable or combustible materials, infectious substances, poisons, dry ice,
                  fireworks, or radioactive materials; and hazardous waste.
                </li>
                <li className='pl-4'>
                  Other illegal or restricted goods defined by any shipping partner, or any local, state, federal,
                  national law and regulation.
                </li>
                <li className='pl-4'>Vape products</li>
              </ul>
              <p className='mb-4'>
                You agree and acknowledge that you will not store any item that falls in the category of the
                beforementioned list. We will reject any suspicious packages upon delivery to our storage facility, and
                you will be responsible of the return expenses.
              </p>

              <h3 className='text-3xl sm-mx:text-xl font-bold text-secondary mt-7 mb-3.5'>Pickup and Dropoff</h3>
              <p className='mb-4'>
                It is your responsibility to provide the correct pickup address and instructions, and to make sure all
                packages are correctly labeled and packed before the scheduled pickup date and time. You understand that
                the carrier will not call before the pickup. It is your responsibility to hand the shipment to the
                carrier or to make sure the carrier has easy access to the shipment. Ship And Storage is not responsible
                for missed pickups due to wrong pickup address, package cannot be found, or package is not ready. You
                understand that the pickup timeframe is not guaranteed. Carrier may arrive earlier or later than
                scheduled on the pickup date due to road conditions and/or other reasons. Ship And Storage is not
                responsible for any unsuccessful pickup caused by carrier’s fault.
              </p>
              <p className='mb-4'>
                You understand that the carrier may not confirm the pickup due to weather, traffic, or service area
                factors. Ship And Storage will refund the pickup fee if the pickup cannot be confirmed by the carrier.
                Once the pickup is confirmed, the pickup fee is not refundable. If the pickup failed because of your
                fault (such as package not ready, wrong pickup address, etc.), Ship And Storage reserves the right to
                charge the second pickup. If the pickup failed because of carrier’s fault, Ship And Storage will try to
                schedule a new pickup at your and carrier’s next available time window for free. You understand that the
                delivery time will change correspondingly if the new pickup is not on the original date. If your
                shipment is time sensitive, it is your responsibility to timely change the shipping services or drop off
                the shipment, so the shipment can be delivered at a scheduled time. Ship And Storage is not responsible
                for any shipment delay caused by missed or failed pickups.
              </p>
              <p className='mb-4'>
                Due to the different time zones and office hours, same-day pickup service is not guaranteed. Same-day
                pickup is not available for FedEx Basic service. Saturday pickup is not available for DHL Express
                service and FedEx Basic service. Ship And Storage does not provide Sunday or holiday pickups for all
                services.
              </p>
              <p className='mb-4'>
                It is your responsibility to drop off the package before the service cut-off time at the carrier’s
                drop-off location and request a drop-off receipt with drop-off date, time, and shipment tracking
                number(s). You acknowledge that you will not drop off the shipment incorrectly to a carrier’s street
                dropbox or non-staffed shipping center. Ship And Storage is not responsible for the shipment delay or
                loss because of the late or incorrect drop off.
              </p>

              <h3 className='text-3xl sm-mx:text-xl font-bold text-secondary mt-7 mb-3.5'>Delivery and Collection</h3>
              <p className='mb-4'>
                It is your responsibility to provide the correct delivery address and instructions. Ship And Storage is
                not responsible for delayed, lost, or returned shipment due to wrong or incomplete delivery address. You
                agree to have someone accept and sign for the package at the delivery address. Ship And Storage is not
                responsible for any lost or missing package after delivery.
              </p>
              <p className='mb-4'>
                Upon delivery to you by the carrier, if the content inside the package is damaged or broken because the
                luggage/box/bag was damaged in transit, it is your responsibility to keep full evidence to assist Ship
                And Storage to file a claim with the carrier. The evidence includes, but not limited to:
              </p>

              <ul className='list-disc pl-5 mb-5'>
                <li className='pl-4'>damaged/broken package picture with attached label</li>
                <li className='pl-4'>damaged/broken item pictures</li>
                <li className='pl-4'>write “package received damaged or broken” when you sign for the package</li>
              </ul>
              <p>
                If you selected “delivery without signature” when placing the order, you understand that you will not be
                able to file a claim once the shipment tracking shows delivered on carrier’s website.
              </p>
              <p className='mb-4'>
                Carrier may try a second delivery if the first delivery attempt was missed. It is your responsibility to
                have someone accept the shipment at the delivery address. Carrier may also hold the shipment at a nearby
                station for your collection if the first delivery attempt failed. You agree to show your photo ID to
                collect the shipment. Ship And Storage will not cover the additional cost incurred for the package hold
                and collection.
              </p>
              <p className='mb-4'>
                If you do not collect the shipment within the timeframe the carrier is able to hold, or the package is
                defined as an undeliverable package because of the wrong address, it will be returned by carrier. You
                agree to be responsible for the return cost and other additional costs associated to the return.
              </p>

              <h3 className='text-3xl sm-mx:text-xl font-bold text-secondary mt-7 mb-3.5'>International Shipments</h3>
              <p className='mb-4'>
                Please know in advance if you are shipping international after using our storage services. Every
                international shipment is subject to customs clearance. You acknowledge it is your responsibility to
                understand the local customs regulations and requirements to import and export your items. You are
                responsible for providing a full and correct item details for Ship And Storage to create the customs
                invoice. It is also your and your receiver’s responsibility to timely and actively cooperate with local
                customs and the carrier and provide all required documents and information for customs clearance.
              </p>
              <p className='mb-4'>
                Ship And Storage is not responsible for customs delay. If you and/or receiver do not comply with the
                local customs authorities, provide the necessary documents, and pay for duties and taxes, customs have
                the right to return, hold, or destroy the packages according to the destination country's law and
                regulation. You agree to take full responsibility for the loss or return cost and will not dispute the
                shipping services and shipping fees with Ship And Storage.
              </p>
              <p className='mb-4'>
                You understand customs has the right to hold and open your package, inspect and re-value the items
                inside the package, and levy duties and taxes based on their assessment. You acknowledge and agree to be
                fully responsible for the duties and taxes, and any other customs charges, such as brokerage fees, or
                customs warehouse fee if applied. If you refuse to pay for duties and taxes, and the carrier charges the
                duties and taxes to Ship And Storage, Ship And Storage has the right to charge your credit card at the
                billed amount.
              </p>
              <p className='mb-4'>
                It is your responsibility not to ship restricted or prohibited items, and not to lock your packages. You
                understand that customs or carrier may return the locked package if they are not able to open it for a
                regular customs screening. Ship And Storage is not responsible for any shipment delay, hold, or return
                because of the restricted or prohibited items, and for any shipment loss or delay because of the locked
                package. We are unable to remove these items for you and unlock the packages.
              </p>
              <p className='mb-4'>
                If the sender or receiver is on the carrier, government, or United Nations’ Denied Persons List, the
                carrier has the right to refuse, hold, or return the shipment. You agree that Ship And Storage is not
                responsible for the delay, return, or refusal of the shipment. You acknowledge to cover all related
                fees, including but not limited to original shipping fee, return fee, investigation fee, and so forth.
              </p>
              <p className='mb-4'>
                You understand that carrier has the right to deliver the package to a third-party broker for clearance
                per local customs regulation. You agree to cooperate with the carrier and the broker’s company for the
                clearance and pay for brokerage fee and any related fee if applied. Ship And Storage is not responsible
                for any customs delay, shipment returned or destroyed because you refused to cooperate with the broker
                and the carrier.
              </p>

              <h3 className='text-3xl sm-mx:text-xl font-bold text-secondary mt-7 mb-3.5'>Missing Shipment</h3>
              <p className='mb-4'>
                Ship And Storage will assist in monitoring your shipment and communicate with the carrier if the
                shipment tracking stops updating for more than 3 business days. It is your responsibility to monitor
                your shipment tracking and provide full and detailed package size, color, and content information so the
                carrier can search and try to find the missing package.
              </p>
              <p className='mb-4'>
                If the carrier confirms unable to locate the package, Ship And Storage will file a lost claim with the
                carrier once the other package(s) of the shipment is delivered. If the carrier finds and delivers the
                missing package, you may request a delay claim if conditions mentioned in the “Shipment delay” section
                of these terms apply.
              </p>

              <h3 className='text-3xl sm-mx:text-xl font-bold text-secondary mt-7 mb-3.5'>
                Insurance, Liability, and Discretionary Compensation
              </h3>
              <p className='mb-4'>
                Ship And Storage provides up to 250 USD free insurance coverage for each package. Additional shipping
                insurance coverage from the carrier or third-party insurance company is available for purchase when you
                are placing an order. Coverage for damage is only 25% of the selected insurance for the respective
                damaged package. You are responsible for ensuring sufficient insurance coverage to protect the shipment.
                Ship And Storage’s liability is not applicable to additional shipping insurance purchased by you. Ship
                And Storage will file a claim on behalf of you. The carrier or third-party insurance company
                investigates and makes the final decision. In no event shall Ship And Storage be liable for the
                additional shipping insurance coverage and related claim result.
              </p>
              <p className='mb-4'>You understand that insurance only covers:</p>
              <ul className='list-disc pl-5 mb-10'>
                <li className='pl-4'>Lost shipment</li>
                <li className='pl-4'>Items damaged caused by box/bag/luggage extremely damaged in transit.</li>
              </ul>
              <p className='mb-4'>You understand the insurance DOES NOT COVER:</p>
              <ul className='list-disc pl-5 mb-10'>
                <li className='pl-4'>
                  Cosmetic damage of the luggage/bag/box. FedEx and DHL consider luggage/bag/box as packaging materials.
                  It is your responsibility to select proper and strong luggage/bag/box for the transportation. You
                  acknowledge that Ship And Storage is not able to file a damage claim only for damaged packaging
                  materials (luggage/bag/box).
                </li>
                <li className='pl-4'>Fragile items including any breakable or temperature-sensitive items</li>
                <li className='pl-4'>
                  Glassware including, but not limited to, signs, mirrors, ceramics, porcelains, china, crystal, glass,
                  framed glass, and any other commodity with similarly fragile qualities
                </li>
                <li className='pl-4'>
                  Electronics including, but not limited to, laptops, cameras, personal computers, stereo equipment,
                  personal audio devices, cell phones, TV.
                </li>
                <li className='pl-4'>
                  Antiques, collector’s items, precious metals and gems, works of art, precious jewelry
                </li>
                <li className='pl-4'>
                  Any prohibited items listed in our terms and conditions, or any prohibited items prohibited or
                  restricted by local, country, international law or regulation,
                </li>
                <li className='pl-4'>Shipment delay including but not limited to customs delay</li>
                <li className='pl-4'>Storage services.</li>
              </ul>
              <p className='mb-4'>
                You also understand the shipping insurance DOES NOT cover the loss or damage arising from the following
                circumstances:
              </p>
              <ul className='list-disc pl-5 mb-10'>
                <li className='pl-4'>
                  Strike, lock-out, stoppage or restraint of labor, Customs delay, the consequences of which we are
                  unable to avoid by the exercise of reasonable diligence
                </li>
                <li className='pl-4'>Acts of God</li>
                <li className='pl-4'>Consequence of War or Terrorism</li>
                <li className='pl-4'>
                  Any item damaged or lost because of your improper packing and/or labeling. You understand that your
                  items must be thoroughly packaged and must be able to fall approximately 38 inches without breaking.
                </li>
                <li className='pl-4'>
                  Any item damaged or lost because of improper outer container (box, luggage, or bag) you used for the
                  shipment. You understand that the outer container you select should be sturdy enough to hold and
                  protect all items inside it. It should also be strong enough for other packages to be stacked on it in
                  transit.
                </li>
                <li className='pl-4'>
                  Any loss or damage after package has been signed for and accepted at the wrong or incomplete delivery
                  address provided by you
                </li>
                <li className='pl-4'>
                  Any loss or damage after package has been delivered without a signature request
                </li>
                <li className='pl-4'>
                  Any loss or damage before the carrier pick up the shipment, or before the carrier accepted the drop
                  off package.
                </li>
                <li className='pl-4'>You failed to adhere to the terms and conditions set out in these conditions</li>
              </ul>

              <p className='mb-4'>
                It is your responsibility to send Ship And Storage a picture(s) of your labeled luggage/box/bag before
                you hand your luggage/box/bag to the carrier. You understand your lost or damage claim will not be
                accepted by the carrier if you do not send the picture before the carrier pickup or your drop-off. Ship
                And Storage will not be responsible for any rejected claim because of lack of picture evidence.
              </p>
              <p className='mb-4'>
                You agree to file a claim with Ship And Storage for the lost or damaged shipment. Lost claim needs to be
                submitted within 5 business days from the estimated delivery date. The claim should be sent by email
                with the lost item list and purchase invoice. Damage claim needs to be submitted within 3 business days
                after the shipment is delivered. The claim should be sent by email with pictures of the damaged package
                and damaged items, damaged item value list and purchase invoice.
              </p>
              <p className='mb-4'>
                Ship And Storage assists to collect all claim documents and submit the claim on behalf of you. In no
                event shall Ship And Storage be responsible for the claim result. The carrier or third-party insurance
                company will investigate and decide the claim result and compensation amount per their insurance policy
                and inspection. The claim investigation will usually take 15-30 business days. Once the decision is
                made, it will be the final decision and settlement for the claim.
              </p>
              <p className='mb-4'>
                Ship And Storage will process the refund within 5 business days after the claim is approved by the
                carrier or third-party insurance company. You agree to file a lost or damage claim through Ship And
                Storage. You understand the lost or damage claim may be rejected if you file it directly with the
                carrier. You acknowledge that Ship And Storage will not responsible for any rejection because you filed
                the claim directly with the carrier. You acknowledge that if carrier resolves a claim by paying full
                value for a shipment, carrier reserves the right to pick up the package for salvage, and all rights,
                title to, and interest in the package shall vest with the carrier.
              </p>

              <h3 className='text-3xl sm-mx:text-xl font-bold text-secondary mt-7 mb-3.5'>Promotion Code</h3>
              <p className='mb-4'>
                Ship And Storage may offer promotion code to members. All discounts are applied at the sole discretion
                of Ship And Storage and may be withdrawn at any time. The discounted amount applied by a promotion code
                cannot be refunded if you cancel the order. If an expected discount fails to apply to your order, please
                contact us{' '}
                <a href='mailto:support@shipandstorage.com' className='text-secondary underline cursor-pointer'>
                  support@shipandstorage.com
                </a>{' '}
                before submitting the order. Ship And Storage only accepts one valid promotion code per order.
              </p>

              <h3 className='text-3xl sm-mx:text-xl font-bold text-secondary mt-7 mb-3.5'>Limitation of Liability</h3>
              <p className='mb-4'>
                Ship And Storage’s liability is limited to the lower of actual damages/lost or free insurance amount.
                Our maximal liability coverage is up to 250 USD for each package shipped and stored. Ship And Storage is
                not responsible for indirect or consequential loss such as (but not limited to) loss of profit, loss of
                market or the consequences of delay or deviation however caused. Ship And Storage is not responsible for
                any carrier or carrier partner’s service fault (delay, loss, damage, etc.). Ship And Storage is not
                responsible for any loss, damage, or delay caused by events beyond our control, including but not
                limited to acts of God, war, civil unrest, or acts of government. Ship And Storage is not the original
                shipper of your package and has no liability for what you ship. Ship And Storage’s liability is not
                applicable to additional insurance purchased by you. Ship And Storage files a claim on behalf of you.
                The carrier or third-party insurance company investigates and makes the final decision. In no event
                shall Ship And Storage be liable for the additional insurance coverage.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default TermsAndConditions
